import "./App.css";
import React, { useState, useEffect } from "react";
import axios from "axios";
import GlobalFunctions from "./Services/GlobalFunctions";
import "bootstrap/dist/css/bootstrap.min.css";
import CustomNavbar from "./Components/Navbar";
import DataService from "./IndexBD/DataService";
import Swal from "sweetalert2";
import DialogoLoading from "./Components/DialogoLoading";
import NewLista from "./Listas/NewLista";
import Login from "./Login/Login";
import { useAuth } from "./Auth/AuthContext";
import PrivateRoute from "./Components/PrivateRoute";
import DetalleCliente from "./DetalleCliente/DetalleCliente";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Link
} from "react-router-dom";
import Requests from "./Solicitudes/Requests";
import IngresarPrest from "./Cotizar/IngresarPrest";
import PrestamoAmortizado from "./Cotizar/PrestamoAmortizado";

function App() {
  const glob = new GlobalFunctions();
  const [clientes, setClientes] = useState([]);
  const [carteras, setCarteras] = useState([]);
  const { isAuthenticated, logout } = useAuth();
  const API_URL = process.env.REACT_APP_API_URL;
  const [detalleCliente, setDetalleCliente] = useState({
    Cobro: "",
    abonos: [],
    apellidos: "",
    cedula: "",
    ciudad: "",
    departamento: "",
    difusion: "",
    dir_fiador: "",
    direccion: "",
    direccion_trabajo: "",
    fecha_ingreso: "",
    fecha_nacimiento: "",
    imagen: "",
    info_direccion: "",
    nombre: "",
    nombreCompleto: "",
    nombre_fiador: "",
    otro_rifa: "",
    otros: "",
    prestamo: {
      cedula: "",
      fecha_prest: "",
      valorprestamo: 0,
      tiempo_meses: 0,
      interes: 0,
    },
    revisado: "",
    tel_fiador: "",
    telefonos: [],
    telefono_trabajo: "",
    valor_letra: "",
  });

  useEffect(() => {
    if (isAuthenticated == false) {
      if (document.getElementById("linkLogin") != null) {
        document.getElementById("linkLogin").click();
        return;
      }
    }
    fetchData();
  }, [isAuthenticated]);

  const handlePopState = () => {
    if (
      window.location.href == process.env.REACT_APP_MY_URL &&
      detalleCliente.cedula != ""
    ) {
      setDetalleCliente({
        Cobro: "",
        abonos: [],
        apellidos: "",
        cedula: "",
        ciudad: "",
        departamento: "",
        difusion: "",
        dir_fiador: "",
        direccion: "",
        direccion_trabajo: "",
        fecha_ingreso: "",
        fecha_nacimiento: "",
        imagen: "",
        info_direccion: "",
        nombre: "",
        nombreCompleto: "",
        nombre_fiador: "",
        otro_rifa: "",
        otros: "",
        prestamo: {
          cedula: "",
          fecha_prest: "",
          valorprestamo: 0,
          tiempo_meses: 0,
          interes: 0,
        },
        revisado: "",
        tel_fiador: "",
        telefonos: [],
        telefono_trabajo: "",
        valor_letra: "",
      });
    }
  };

  window.addEventListener("popstate", handlePopState);

  const fetchData = async () => {
    try {
      const data = await DataService.loadAllData("clientes");
      //Se hace necesaria la cookie ya que isAuthenticated demora en actualizarse y me manda el dialogo
      //aun cuando se ha cerrado sesion...
      const sessionCookie = glob.getCookie("session");
      if (sessionCookie != "") {
        if (sessionCookie == "true" && data.length == 0) {
          confirmarTraerDatos("");
        } else {
          setClientes(data);
          const cartes = await DataService.loadAllData("carteras");
          if (cartes.length > 0) {
            setCarteras(cartes);
          }
        }
      }
    } catch (error) {}
  };

  function confirmarTraerDatos(from) {
    if (from == "navbar") {
      document.getElementById("btnToggleNavbar").click();
    }
    let mensaje =
      "¿Actualizar clientes? Se borrará la lista de clientes que se carga actualmente.";
    if (clientes.length == 0) {
      mensaje = "¿Actualizar clientes?";
    }
    Swal.fire({
      title: mensaje,
      showCancelButton: true,
      confirmButtonColor: "green",
      confirmButtonText: "Confirmar",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        fetchGetPrestamosAbonos();
      }
    });
  }

  function loading() {
    document.getElementById("btnOpenModalLoading").click();
  }

  const fetchGetPrestamosAbonos = async () => {
    document.getElementById("btnOpenModalLoading").click();
    const url = API_URL + "/getprestamos";
    try {
      axios.get(url).then((response) => {
        if (response.data.clientes.length > 0) {
          DataService.saveData("clientes", response.data.clientes);
          DataService.saveData("carteras", response.data.carteras);
          glob.setCookie("fecha_copia", glob.getFecha(), 3600 * 24 * 30);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Clientes, préstamos y abonos actualizados.",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            window.location.reload();
          }, 100);
        } else {
          document.getElementById("btnMainCerrarSesion").click();
        }
        document.getElementById("btnCloseModalLoading").click();
      });
    } catch (err) {
      document.getElementById("btnMainCerrarSesion").click();
    }
  };

  function validarDetalleCliente(cliente) {
    const online = glob.getCookie("online");
    if (online != "") {
      if (online === "true") {
        let href =
          process.env.REACT_APP_URL_ROOT + "client/" + cliente.cedula + "/edit";
        window.open(
          href,
          "nuevo",
          "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=800, height=600"
        );
      } else {
        setDetalleCliente(cliente);
        document.getElementById("linkDetalleCliente").click();
      }
    } else {
      setDetalleCliente(cliente);
      document.getElementById("linkDetalleCliente").click();
    }
  }

  function hacerSolicitud() {
    document.getElementById("btnToggleNavbar").click();
    document.getElementById("linkSolicitud").click();
  }

  function goLista(from) {
    if (from == "navbar") {
      document.getElementById("btnToggleNavbar").click();
    }
    document.getElementById("linkLista").click();
    setDetalleCliente({
      Cobro: "",
      abonos: [],
      apellidos: "",
      cedula: "",
      ciudad: "",
      departamento: "",
      difusion: "",
      dir_fiador: "",
      direccion: "",
      direccion_trabajo: "",
      fecha_ingreso: "",
      fecha_nacimiento: "",
      imagen: "",
      info_direccion: "",
      nombre: "",
      nombreCompleto: "",
      nombre_fiador: "",
      otro_rifa: "",
      otros: "",
      prestamo: {
        cedula: "",
        fecha_prest: "",
        valorprestamo: 0,
        tiempo_meses: 0,
        interes: 0,
      },
      revisado: "",
      tel_fiador: "",
      telefonos: [],
      telefono_trabajo: "",
      valor_letra: "",
    });
  }

  function goCotizar(from) {
     if (from == "navbar") {
      document.getElementById("btnToggleNavbar").click();
    }
    document.getElementById("btnOpenCotizar").click();
  }

  function goAmortizado() {
    document.getElementById("btnOpenCotizarAmortizado").click();
  }

  return (
    <div className="App">
      <button
        id="btnMainCerrarSesion"
        onClick={logout}
        style={{ display: "none" }}
      ></button>
      <PrivateRoute>
        <div style={{ display: isAuthenticated ? "" : "none" }}>
          <CustomNavbar
            confirmarTraerDatos={confirmarTraerDatos}
            clientes={clientes}
            validarDetalleCliente={validarDetalleCliente}
            hacerSolicitud={hacerSolicitud}
            goLista={goLista}
            loading={loading}
            cotizar={goCotizar}
          />
        </div>
        <Router>
          <Link id="linkLista" style={{ display: "none" }} to="/"></Link>
          <Link id="linkLogin" style={{ display: "none" }} to="/login"></Link>
          <Link
            id="linkDetalleCliente"
            style={{ display: "none" }}
            to="/detalle"
          ></Link>
          <Link
            id="linkSolicitud"
            style={{ display: "none" }}
            to="/request"
          ></Link>
          <Routes>
            <Route
              path="/"
              element={
                <NewLista carteras={carteras} clientes={clientes}></NewLista>
              }
            />
            <Route path="/login" element={<Login></Login>} />
            <Route
              path="/detalle"
              element={<DetalleCliente cliente={detalleCliente} />}
            />
            <Route
              path="/request"
              element={
                <Requests goLista={goLista} cliente={detalleCliente}></Requests>
              }
            />
          </Routes>
        </Router>
      </PrivateRoute>
      <button
        style={{ display: "none" }}
        data-toggle="modal"
        data-target="#prestamoModal"
        id="btnOpenCotizar"
      >
      </button>
      <IngresarPrest goAmortizado={goAmortizado}></IngresarPrest>
      <button
        style={{ display: "none" }}
        data-toggle="modal"
        data-target="#prestamoAmortModal"
        id="btnOpenCotizarAmortizado"
      >
      </button>
      <PrestamoAmortizado></PrestamoAmortizado>
      <DialogoLoading></DialogoLoading>
    </div>
  );
}

export default App;
